import React, { useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';
import { ReactComponent as Carrot } from '../../../svg/Carrot.svg';
import { Color3D } from '../Elements/Color3D';
import { Textile3D } from '../Elements/Textile3D';
import { StepHeaderTextDescription } from '../Elements/StepHeaderTextDescription';
import LoadingPage from '../../LoadingPage';
import ColorsAndTextilesConfig from '../Config/colorsAndTextiles.config';
import getProduct from '../Data/GetProduct';
import VariantTextileMapConfig from '../Config/variantTextileMap.config';
import { ProductPrice } from '../Elements/Product/ProductPrice';


const StyledWrapperStepFour = styled('div')`
  display: flex;
  flex-direction: column;
  margin: 0 auto 4rem;
  width: 100%;
`;
const CharpstarWrapper = styled('div')`
  width: 100%;
  height: 500px;
  margin: 0 0 2rem;
  background: #f5f5f5;
  @media screen and (max-width: 800px) {
    margin: 0 0 1rem;
    height: 45vh;
  }
`;
const CharpstarContainer = styled('div')`
  width: 100%;
  position: relative;
  max-width: 1280px;
  padding: 0 60px;
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 1023px) {
    padding: 0 10px;
  }
  @media screen and (max-width: 800px) {
    height: 45vh;
  }
`;

const ContentWrapper = styled('div')`
    width: 100%;
  border-radius: 30px 30px 0 0;
`

const StepHeader = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  width: 100%;
  position: relative;
  margin: 0 auto 2rem;
  height: 35px;
  max-width: 1280px;
  padding: 0 60px;
  @media screen and (max-width: 1023px) {
    padding: 0 10px;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media screen and (max-width: 800px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }  
`;
const StepHeaderText = styled('div')`
  font-weight: bold;
  font-size: 18px;
  @media screen and (max-width: 800px) {
    font-size: 16px;
    width: 100%;
    margin: 0 40px 0 0;
  }
`;
const StepHeaderButton = styled('div')`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  width: 100px;
  height: 35px;
  position: absolute;
  right: 0;
  cursor: pointer;
  display: ${({ active }) => (active ? 'flex' : 'none')};
  top: 50%;
  transform: translateY(-50%);
  @media screen and (max-width: 1023px) {
    right: 0;
  }
  @media screen and (max-width: 800px) {
    right: 0;
  }
`;
const StepHeaderButtonPrev = styled('div')`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  width: 35px;
  height: 35px;
  position: absolute;
  left: 0;
  cursor: pointer;
  display: flex;
  top: 50%;
  transform: translateY(-50%);
  @media screen and (max-width: 1023px) {
    left: 0;
  }
  @media screen and (max-width: 800px) {
    left: 0;
  }
`;
const StepHeaderButtonText = styled('p')`
  margin: 5px 0;
  color: #fff;
`;
const SvgWrapper = styled('div')`
  width: 15px;
  transition: transform 0.3s;

  svg {
    use {
      fill: #fff;
    }
  }
  transform: rotate(-90deg);
`;
const SvgWrapperReverse = styled('div')`
  width: 15px;
  transition: transform 0.3s;

  svg {
    use {
      fill: #fff;
    }
  }
  transform: rotate(90deg);
`;
const ColorWrapper = styled('div')`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  max-width: 1280px;
  width: 100%;
  padding: 0 60px;
  margin: 0 auto;
  /* width */
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #911827;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #720714;
  }
  @media screen and (max-width: 1023px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 0 30px 5px 10px;
    max-width: unset;
    overflow-y: hidden;
  }
`;
const TextileWrapper = styled('div')`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-gap: 15px;
  gap: 15px;
  width: 100%;
  position: relative;
  min-height: 0;
  min-width: 0;
  margin: 30px auto 0;
  max-width: 1280px;
  padding: 0 60px;
  /* width */
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #911827;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #720714;
  }

  @media screen and (max-width: 1023px) {
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
  }
  
  @media screen and (max-width: 800px) {
    padding: 0 30px 0 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
  }
  
`;
const TextileOverlay = styled('div')`
  position: absolute;
  top: -10px;
  left: 0;
  width: 100%;
  background: #fff;
  min-height: calc(100% + 30px);
  z-index: 3;
  padding: 0 60px;
  @media screen and (max-width: 1023px) {
    padding: 0 10px;
  }
`;
const Textile = styled('div')``;
const TextileButton3DBackground = styled('div')``;
const TextileButton3DBackgroundImage = styled('img')`
  width: 100%;
  height: auto;
  max-height: 200px;
  object-fit: contain;
`;
const TextileInfoWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;
const TextileInfo = styled('p')`
  margin: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;
const TextileInfoName = styled('span')`
  margin: 0;
  font-weight: 700;
  text-align: left;
  font-size: 16px;
  line-height: 1;
`;
const TextileInfoSubtitle = styled('span')`
  margin: 0;
  font-weight: 400;
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
`;
const TextileCloseButton = styled('button')`
  text-transform: uppercase;
  font-size: 14px;
  border-radius: 50px;
  margin: 0;
  background: #911827;
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 10px;
  width: 100px;
  height: 35px;
`;

const ProductInfo = styled('div')`
  position: absolute;
  top: 20px;
  left: 60px;
  z-index: 10;
  text-align: left;

  @media screen and (max-width: 1023px) {
    left: 20px;
  }
`;
const ProductName = styled('p')`
  margin: 0;
  font-weight: 700;
  @media screen and (max-width: 600px) {
    font-size: 14px;
  }
`;
const findTextileByName = (name) => {
  const textile = ColorsAndTextilesConfig.textiles.find((t) => t.name === name);
  if (textile && textile.smallImage && textile.publicName) {
    return textile;
  }
  return null;
};

export const ColorStep = ({
                            currentStep,
                            setCurrentStep,
                            activeProduct,
                            setActiveProduct,
                            activeCategory,
                            setActiveCategory,
                            activeTextileIndex,
                            setActiveTextileIndex,
                            activeLeg,
                            setActiveLeg,
                          }) => {

  const colorGroups = ColorsAndTextilesConfig.colors;
  const [activeIndex, setActiveIndex] = useState(null);
  const [defaultArticleNumberForVariant, setDefaultArticleNumberForVariant] = useState(null);
  const [availableVariants, setAvailableVariants] = useState([]);
  const [textiles, setTextiles] = useState(() => {
    // Try to load from sessionStorage on first render
    try {
      const stored = sessionStorage.getItem('mobelmastarna_3d_textiles');
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });
  const [openTextile, setOpenTextile] = useState(false);
  const [isCharpstarLoaded, setIsCharpstarLoaded] = useState(false);
  const [productPrice, setProductPrice] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null)
  const [charpstARConfig, setCharpstARConfig] = useState(null);


  const productData = activeProduct?.defaultArticleNumber
    ? getProduct(activeProduct.defaultArticleNumber)
    : null;

  useEffect(() => {
    (async () => {
      try {
        // Note: This only works if the script is an ES module AND your bundler allows it!
        const module = await import(/* webpackIgnore: true */ 'https://js.charpstar.net/MobelMastarna/charpstAR-MobelMastarna-v2.js');
        setCharpstARConfig(module.default);
        // Use module exports here
      } catch (error) {
        console.error('Failed to load module:', error);
      }
    })();
  }, [charpstARConfig]);

  useEffect(() => {
    // Only clear when coming from a previous step (not when going back from a later step)
    // For example, if ColorStep is step 3, clear if previous step was 2
    // You may need to adjust the step numbers based on your flow
    if (currentStep === 3 && window.sessionStorage.getItem('lastStep')) {
      const lastStep = Number(window.sessionStorage.getItem('lastStep'));
      if (lastStep < 3) {
        sessionStorage.removeItem('mobelmastarna_3d_textiles');
      }
    };
  }, [currentStep]);
  useEffect(() => {
    if (
      charpstARConfig === null ||
      typeof charpstARConfig === 'undefined' ||
      !defaultArticleNumberForVariant ||
      isCharpstarLoaded
    ) {
      return;
    }
    if (!defaultArticleNumberForVariant) return;
    charpstARConfig
      .init()
      .then(() => {
        const intervalId = setInterval(() => {
          if (charpstARConfig.viewerElement !== null) {
            charpstARConfig.viewerElement.style.opacity = 0;
            clearInterval(intervalId);
            setIsCharpstarLoaded(true);
          } else {
            // Waiting for viewerElement to be ready
          }
        }, 10);
      })
      .catch((error) => {
        console.error('charpstARConfig initialization failed:', error);
      });
  }, [charpstARConfig, defaultArticleNumberForVariant, isCharpstarLoaded]);
  // 2. Load textiles when charpstar is loaded (only once, and store in sessionStorage)
  useEffect(() => {
    if (charpstARConfig === null || !isCharpstarLoaded || textiles.length > 0) return;
    const intervalId = setInterval(() => {
      const fabrics = charpstARConfig.getAvailableFabricMaterials();
      if (Array.isArray(fabrics) && fabrics.length > 0) {
        const textileArr = fabrics.map((fabric, index) => ({
          id: index,
          name: fabric,
          image: '',
          hexColor: '',
        }));
        setTextiles(textileArr);
        sessionStorage.setItem('mobelmastarna_3d_textiles', JSON.stringify(textileArr));
        charpstARConfig.setViewToFabric();
        clearInterval(intervalId);
      }
    }, 100);
    return () => clearInterval(intervalId);
  }, [isCharpstarLoaded, textiles.length, activeTextileIndex, charpstARConfig]);
  // 3. Set fabric material when textile changes
  useEffect(() => {
    if (charpstARConfig === null) {
      return;
    }
    if (!isCharpstarLoaded)  {
      return;
    }
    if (activeTextileIndex === null)  {
      return;
    }
    if (!textiles[activeTextileIndex]) {
      return;
    }


    charpstARConfig.setFabricMaterial(textiles[activeTextileIndex].name);
    // Find the color group index for the selected textile
    const groupIndex = colorGroups.findIndex(group =>
      group.textiles.includes(textiles[activeTextileIndex].name)
    );
    setActiveIndex(groupIndex !== -1 ? groupIndex : 0);
    //setActiveIndex
  }, [activeTextileIndex, textiles, isCharpstarLoaded, colorGroups, charpstARConfig]);
  useEffect(() => {
    if (charpstARConfig === null || !isCharpstarLoaded) {
      return
    }
    if (isCharpstarLoaded && charpstARConfig.viewerElement) {
      charpstARConfig.viewerElement.style.opacity = 1;
    }
  }, [charpstARConfig, isCharpstarLoaded]);
  useEffect(() => {
    if (!productData) return;
    if (!activeProduct) return;

    let tmpAvailableVariants = [];
    let defaultExists = false
    productData.variants.values.forEach((variant) => {
      if (variant.articleNumber === activeProduct.articleNumbers[0]) {
        defaultExists = true
      }
      if (activeProduct.articleNumbers.includes(variant.articleNumber)) {
        tmpAvailableVariants.push(variant.articleNumber);
      }
    });
    setAvailableVariants(tmpAvailableVariants);
    setDefaultArticleNumberForVariant(activeProduct.articleNumbers[0]);
  }, [productData, activeProduct]);
  useEffect(() => {
    if (
      activeIndex === null &&
      colorGroups.length > 0 &&
      textiles.length > 0
    ) {
      const firstAvailableIndex = colorGroups.findIndex(color =>
        color.textiles.some(textileName =>
          textiles.some(t => t.name === textileName)
        )
      );
      if (firstAvailableIndex !== -1) {
        setActiveIndex(firstAvailableIndex);
      }
    }
  }, [activeIndex, colorGroups, textiles]);
  useEffect(() => {
    if (
      activeIndex !== null &&
      activeTextileIndex === null &&
      textiles.length > 0 &&
      colorGroups[activeIndex]
    ) {
      const firstTextileName = colorGroups[activeIndex].textiles.find(name =>
        textiles.some(t => t.name === name && findTextileByName(t.name))
      );
      if (firstTextileName) {
        // eslint-disable-next-line array-callback-return
        textiles.map((textile, index) => {
          if (textile.name === firstTextileName) {
            setActiveTextileIndex(index)
          }
        })
      }
    }
  }, [activeIndex, textiles, activeTextileIndex, colorGroups, setActiveTextileIndex]);

  useEffect(() => {
    if (activeTextileIndex === null) return
    if (!textiles[activeTextileIndex]) return
    if (!activeProduct) return;
    if (!availableVariants.length) return;

    const textileName = textiles[activeTextileIndex]?.name?.toLowerCase().trim();
    const configMatch = VariantTextileMapConfig.filter(
      (item) => item.prefix.toLowerCase().trim() === textileName
    );

    const variantArticleNumbers = productData?.variants?.values?.map(
      (variant) => variant.articleNumber
    ) || [];

    const matchingArticleNumbers = configMatch
      .map((item) => item.articleNumber)
      .filter((articleNumber) => variantArticleNumbers.includes(articleNumber));

    let selectedVariant = matchingArticleNumbers[0];
    // eslint-disable-next-line array-callback-return
    matchingArticleNumbers.map((matchingArticleNumber, index) => {
      if (availableVariants.includes(matchingArticleNumber)) {
        selectedVariant = matchingArticleNumber
      }
    })

    const selectedVariantObj = productData?.variants?.values?.find(
      (variant) => variant.articleNumber === selectedVariant
    );

    const selectedArticleNumber = selectedVariantObj?.articleNumber
    const incVatPrice = selectedVariantObj?.price?.incVat;
    setSelectedVariant(selectedArticleNumber)
    setProductPrice(incVatPrice)
    const previousPrice = selectedVariantObj?.previousPrice?.incVat ? selectedVariantObj.previousPrice.incVat : 0;
    let pricePrevious = '0,00'
    let discountPrice = '0,00'
    let price = '0,00'
    setProductPrice('0,00')
    if (previousPrice && incVatPrice !== selectedVariantObj?.previousPrice.incVat) {
      discountPrice = selectedVariantObj?.price.incVat
      pricePrevious = selectedVariantObj?.previousPrice.incVat
    } else {
      price = incVatPrice
    }
    if (discountPrice && discountPrice !== '0,00') {
      setDiscount(discountPrice.toString().replace('.', ','));
      if (pricePrevious) {
        setProductPrice(pricePrevious.toString().replace('.', ','));
      }
    } else {
      if (price) {
        setProductPrice(price.toString().replace('.', ','));
      }
    }

  }, [productData?.variants?.values, activeTextileIndex, textiles, productPrice, availableVariants, activeProduct, selectedVariant]);

  // Render loading until client-only data is ready
  if (typeof window === 'undefined' || !productData || !defaultArticleNumberForVariant || !availableVariants.length || productPrice === null || selectedVariant === null) {
    return (
      <>
        <StyledWrapperStepFour id="3d-wrapper">
          <CharpstarWrapper>
            <CharpstarContainer>
              <ProductInfo>
              </ProductInfo>
            {
              <charpstar-container data-product={activeProduct.articleNumbers[0]}></charpstar-container>
            }
            </CharpstarContainer>
          </CharpstarWrapper>
          <StepHeader>
            <div style={{position: 'relative'}}>
              <StepHeaderButtonPrev
                active={1}
                onClick={() => {
                  setCurrentStep((i) => i - 1);
                  setActiveProduct(null);
                  window.sessionStorage.setItem('lastStep', (currentStep - 1));
                }}
              >
                <SvgWrapperReverse>
                  <Carrot />
                </SvgWrapperReverse>
              </StepHeaderButtonPrev>
            </div>
            <StepHeaderText>
              {t('Färg och tyg')}
              <StepHeaderTextDescription>3/5</StepHeaderTextDescription>
            </StepHeaderText>
            <div style={{position: 'relative'}}>
              <StepHeaderButton
                active={0}
                onClick={() => {
                  setCurrentStep((i) => i + 1);
                  const updatedProduct = { ...activeProduct, productData };
                  setActiveProduct(updatedProduct);
                  setActiveTextileIndex(activeTextileIndex);
                  window.sessionStorage.setItem('lastStep', currentStep);
                }}
              >
                <StepHeaderButtonText>{t('Nästa')}</StepHeaderButtonText>
                <SvgWrapper>
                  <Carrot />
                </SvgWrapper>
              </StepHeaderButton>
            </div>
          </StepHeader>
        </StyledWrapperStepFour>
      </>
    );
  }



  // 6. Main render
  return (
    <>
      <StyledWrapperStepFour id="3d-wrapper">
        <CharpstarWrapper>
          <CharpstarContainer>
            <ProductInfo>
              <ProductName>{activeProduct.name}</ProductName>
              <ProductPrice price={productPrice} discount={discount} />
            </ProductInfo>
            <charpstar-container
              data-product={defaultArticleNumberForVariant}
            ></charpstar-container>
          </CharpstarContainer>
        </CharpstarWrapper>
        <ContentWrapper>
          <StepHeader>
            <div style={{position: 'relative'}}>
              <StepHeaderButtonPrev
                active={1}
                onClick={() => {
                  setCurrentStep((i) => i - 1);
                  setActiveProduct(null);
                  setActiveLeg(null)
                  setActiveTextileIndex(null)
                  window.sessionStorage.setItem('lastStep', (currentStep - 1));
                }}
              >
                <SvgWrapperReverse>
                  <Carrot />
                </SvgWrapperReverse>
              </StepHeaderButtonPrev>
            </div>
            <StepHeaderText>
              {t('Färg och tyg')}
              <StepHeaderTextDescription>3/5</StepHeaderTextDescription>
            </StepHeaderText>
            <div style={{position: 'relative'}}>
              <StepHeaderButton
                active={activeTextileIndex !== null ? 1 : 0}
                onClick={() => {
                  setCurrentStep((i) => i + 1);
                  let updatedProduct = { ...activeProduct, productData };
                  updatedProduct = { ...updatedProduct, selectedVariant}
                  updatedProduct = { ...updatedProduct, productPrice}
                  updatedProduct = { ...updatedProduct, discount}
                  setActiveProduct(updatedProduct);
                  setActiveTextileIndex(activeTextileIndex);
                  window.sessionStorage.setItem('lastStep', currentStep);
                }}
              >
                <StepHeaderButtonText>{t('Nästa')}</StepHeaderButtonText>
                <SvgWrapper>
                  <Carrot />
                </SvgWrapper>
              </StepHeaderButton>
            </div>
          </StepHeader>

          {!isCharpstarLoaded || !textiles.length ? (
            <LoadingPage style={{height: '100px'}} />
          ) : (
            <>
              {colorGroups.length ? (
                <ColorWrapper>
                  {colorGroups.map((color, index) => {
                    if(color.textiles.length === 0) return '';
                    // Only show color if at least one textile.textiles exists in textiles
                    const hasMatchingTextile = color.textiles.some(textileName =>
                      textiles.some(t => t.name === textileName)
                    );
                    if (!hasMatchingTextile) return null;
                    return (
                      <Color3D
                        key={index}
                        color={color}
                        active={activeIndex === index}
                        onClick={() => {
                          if (activeIndex === index) {
                            setActiveIndex(null);
                            setActiveTextileIndex(null);
                          } else {
                            setActiveIndex(index);
                            setActiveTextileIndex(null)
                          }
                        }}
                      />
                    );
                  })}
                </ColorWrapper>
              ) : (
                ''
              )}

              {activeIndex !== null ? (
                <TextileWrapper>
                  {textiles.map((textile, textileIndex) => {
                    if (colorGroups[activeIndex].textiles.includes(textile.name)) {
                      return (
                        <Textile3D
                          key={textileIndex}
                          textile={textile}
                          active={activeTextileIndex === textileIndex}
                          onClick={() => {
                            if (activeTextileIndex === textileIndex) {
                            } else {
                              setActiveTextileIndex(textileIndex);
                            }
                          }}
                          openTextile={openTextile}
                          setOpenTextile={setOpenTextile}
                        />
                      );
                    }
                    return null;
                  })}
                  {activeTextileIndex !== null && openTextile ? (
                    (() => {
                      const textileData = findTextileByName(textiles[activeTextileIndex].name);
                      if (!textileData) {
                        return null;
                      }
                      return (
                        <TextileOverlay>
                          <Textile>
                            <TextileButton3DBackground>
                              <TextileButton3DBackgroundImage
                                src={textileData?.bigImage || ''}
                                alt={textileData?.publicName || ''}
                              />
                            </TextileButton3DBackground>
                            <TextileInfoWrapper>
                              <TextileInfo>
                                <TextileInfoName>{textileData?.publicName || ''}</TextileInfoName>
                                <TextileInfoSubtitle>{textileData?.manufacturer + " " + textileData?.fabric || ''}</TextileInfoSubtitle>
                              </TextileInfo>
                              <TextileCloseButton
                                onClick={() => {
                                  setOpenTextile(false);
                                }}
                              >
                                {t('Stäng')}
                              </TextileCloseButton>
                            </TextileInfoWrapper>
                          </Textile>
                        </TextileOverlay>
                      );
                    })()
                  ) : null}
                </TextileWrapper>
              ) : null}
            </>
          )}
        </ContentWrapper>
      </StyledWrapperStepFour>
    </>
  );
};
